var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7147 15.7157C14.5944 16.8245 13.8754 18.3703 13.8077 20.0495H4.94824V18.7474C4.94824 18.0589 5.53399 17.2186 6.96429 16.5035C8.34571 15.8128 10.3047 15.362 12.5003 15.362C13.6758 15.362 14.7563 15.4907 15.7147 15.7157ZM15.8857 8.33073C15.8857 10.1909 14.3605 11.7161 12.5003 11.7161C10.6401 11.7161 9.11491 10.1909 9.11491 8.33073C9.11491 6.47054 10.6401 4.94531 12.5003 4.94531C14.3605 4.94531 15.8857 6.47054 15.8857 8.33073Z",
    stroke: "black",
    strokeWidth: 1.5625
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0104,
    cy: 19.0104,
    r: 2.60417,
    fill: "#45DA66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineUser);
export default __webpack_public_path__ + "static/media/onlineUser.cdd2d686fe6b7390c2b8d377c5ea7548.svg";
export { ForwardRef as ReactComponent };